import { Injectable } from '@angular/core';
import { GoogleModuleOptions } from '@ng-maps/google';
import { Observable } from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {NavResourceService} from "./nav-resource.service";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class GoogleService implements GoogleModuleOptions {
  apiKey: string | undefined;
  libraries = ['places'];

  constructor(private http: HttpClient) {}

  load(): Observable<string> {
    return this.http.get('/api/v1/configs/google').pipe(
      map(res => res['data']),
      tap(key => {
        this.apiKey = key;
        const node = document.createElement('script');
        node.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKey}&libraries=places`;
        node.type = 'text/javascript';
        document.getElementsByTagName('head')[0].appendChild(node);
      }),
    );
  }
}
